import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../../../common/html/element'
import { ScrollComponent } from '../../../../../../../../../common/scrollComponent'
import {
  KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS,
  VALUE_SCORE_ANALYSIS,
} from '../../../../../../../../../tool/dynamicReport/constant'
import { EMPTY_VALUE } from '../../../../../../../../../utils/common'
import {
  SCORE_COLORS_PERFORMANCE,
  SCORE_PERFORMANCE_COLORS_ID,
} from '../../../../../../constant'
import { getIdRangesPerformanceByScore } from '../helper'
import {
  rangesPerformanceRaw,
  selectDataScorePerformance,
  selectRangesPerformance,
} from '../store/slice'
import { RangeScoreLevel } from './RangeScoreLevel'
import classes from './index.module.scss'

export const TopContent = ({ isDynamicReport, settingDynamic }) => {
  const dataScore = useSelector(selectDataScorePerformance())
  const dataRangeRaw = useSelector(rangesPerformanceRaw)
  const arrValueDynamic = isDynamicReport
    ? settingDynamic[KEY_DYNAMIC_SCORE_COMPANY_ANALYSIS.SCORE_ANALYSIS]
    : []

  const { scoreValue, comments } = dataScore

  const nameStartRange = [...dataRangeRaw].pop()?.scoreRangeName
  const nameEndRange = [...dataRangeRaw].shift()?.scoreRangeName
  const rangeScore = useSelector(selectRangesPerformance)
  const idRange = getIdRangesPerformanceByScore(dataRangeRaw, scoreValue)

  const data = rangeScore[idRange]

  const score = () => {
    return (
      <div>
        <div style={{ paddingBottom: 12 }}>
          {!scoreValue ? (
            <>
              <Element className="fw600">
                <Translate value="score.premium.NO_SCORE" />
              </Element>
            </>
          ) : (
            <Element>
              <Element
                elementName="span"
                className="fw600"
                style={{ color: SCORE_PERFORMANCE_COLORS_ID[idRange] }}
              >
                {data?.scoreRangeName}:
              </Element>
              &nbsp;
              <Element elementName="span" style={{ color: '#3A414B' }}>
                {data?.scoreRangeDescription}
              </Element>
            </Element>
          )}
        </div>
        <Element className="dFlex ">
          {scoreValue ? (
            <>
              <RangeScoreLevel
                data={SCORE_COLORS_PERFORMANCE}
                idRange={idRange}
                scoreValue={scoreValue}
                rangeScore={rangeScore}
              />
            </>
          ) : (
            <>
              <Element
                className="w100 dFlex justifyContentCenter alignItemsCenter"
                style={{
                  backgroundColor: '#BCBCBC',
                  height: 34,
                }}
              >
                <Element
                  style={{
                    fontSize: 24,
                    lineHeight: '24px',
                    color: '#FFFFFF',
                  }}
                >
                  {EMPTY_VALUE}
                </Element>
              </Element>
            </>
          )}
        </Element>
        <Element
          className="dFlex justifyContentBetween"
          style={{ marginTop: 4, color: '#3A414B' }}
        >
          <Element>{nameStartRange}</Element>
          <Element>{nameEndRange}</Element>
        </Element>
      </div>
    )
  }

  const detail = () => {
    return (
      <div className="flexColumn h100">
        <Element
          className="fw600"
          style={{
            lineHeight: '16px',
            color: '#3A414B',
            marginBottom: 12,
          }}
        >
          <Translate value="score.main.DETAILS" />
        </Element>
        <div className="flex1">
          <div className="h100">
            <ScrollComponent>
              <Element
                elementName="ul"
                className={classes.ul}
                style={{
                  lineHeight: '16px',
                  color: '#3A414B',
                }}
              >
                {comments?.map((item) => (
                  <li key={item.commentOrder}>
                    <div className="dFlex alignItemsCenter">
                      <div
                        style={{
                          backgroundColor: '#3A414B',
                          borderRadius: '50%',
                          height: 3,
                          width: 3,
                          marginRight: 10,
                        }}
                      />
                      <div>{item?.comment}</div>
                    </div>
                  </li>
                ))}
              </Element>
            </ScrollComponent>
          </div>
        </div>
      </div>
    )
  }

  if (isDynamicReport) {
    if (!arrValueDynamic.includes(VALUE_SCORE_ANALYSIS.SCORE_BAR)) {
      return <></>
    }
    return (
      <Element
        className={classes.topContentCreditRisk}
        style={{ borderColor: '#D5D5D5' }}
      >
        <div className="w70">{score()}</div>
        <div className="w30">{detail()}</div>
      </Element>
    )
  }

  return (
    <Element
      className={classes.topContentCreditRisk}
      style={{ borderColor: '#D5D5D5' }}
      id="TOP_COMPONENT_SCORE_PERFORMANCE"
    >
      <div className="w50">{score()}</div>
      <div className="w50">{detail()}</div>
    </Element>
  )
}
